export const DEFAULT_SELECTED_MENU_KEY = '-1';
